import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Calendar, Trash2, Edit } from 'lucide-react';
import type { Site } from '../../schemas/validation';
import { formatDate } from './utils';

interface SiteCardProps {
  site: Site;
  onDelete: (site: Site) => void;
}

export const SiteCard: React.FC<SiteCardProps> = ({ site, onDelete }) => {
  return (
    <div className="card group min-w-0">
      <div className="p-6 min-w-0">
        <div className="flex items-start justify-between gap-3 mb-4 min-w-0">
          <div className="flex min-w-0 flex-1 items-center space-x-3">
            <div className="w-12 h-12 shrink-0 rounded-xl bg-gradient-to-r from-primary-500 to-primary-600 flex items-center justify-center shadow-sm">
              <Globe className="h-6 w-6 text-white" />
            </div>
            <div className="min-w-0 flex-1 overflow-hidden">
              <div className="flex items-center gap-2 min-w-0">
                <h3 className="text-lg font-semibold text-gray-900 truncate" title={site.name}>
                  {site.name}
                </h3>
                <span
                  className={`shrink-0 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    site.isPublished ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                  }`}
                >
                  {site.isPublished ? 'Published' : 'Draft'}
                </span>
              </div>
              <div className="flex items-center text-sm text-gray-500 mt-1">
                <Calendar className="h-4 w-4 mr-1" />
                <span>Created {formatDate(site.createdAt)}</span>
              </div>
              {site.customDomain && (
                <div className="flex items-center text-sm text-primary-600 mt-1">
                  <Globe className="h-4 w-4 mr-1" />
                  <span className="truncate">{site.customDomain}</span>
                </div>
              )}
            </div>
          </div>
          <button
            type="button"
            onClick={() => onDelete(site)}
            className="shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200 p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg"
            title="Delete website"
          >
            <Trash2 size={16} />
          </button>
        </div>

        <div className="space-y-3">
          <Link
            to={`/sites/${site.id}`}
            className="btn-primary w-full inline-flex items-center justify-center space-x-2"
          >
            <Edit size={16} />
            <span>Edit Website</span>
          </Link>
        </div>
      </div>
    </div>
  );
};
